import React, { useState, useEffect } from 'react';
import { useQueryParams, StringParam, withDefault } from 'use-query-params';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import EmittedIAFPresentational from './EmittedIAFPresentational';
import { useDebouncedCallback } from 'use-debounce';
import {
  getAllBonuses,
  addBonusPaymentDate,
  updateBonus,
} from '../../lib/fetch/reports';
import axios from 'axios';

const MyEmittedIAFPanoramica = ({ location }) => {
  const [t] = useTranslation();
  const [{ newIsAdmin, profile = {}, newToken } = {}] = useAuth();
  const { _id: profileId } = profile;
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [iafs, setIafs] = useState([]);
  const [total, setTotal] = useState(0);
  const [subjects, setSubjects] = useState([]);

  const [query, setQuery] = useQueryParams({
    yearIaf: withDefault(StringParam, ''),
    number: withDefault(StringParam, ''),
    invoiceNumber: withDefault(StringParam, ''),
    admin: withDefault(StringParam, ''),
    limit: withDefault(StringParam, '50'),
    offset: withDefault(StringParam, '0'),
  });

  const [fetchReports] = useDebouncedCallback(async () => {
    showLoading();
    const { error, data, headers } = await getAllBonuses({
      newToken,
      query: { ...query, iafType: 'INSURANCES' },
    });

    if (error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    setIafs(data);
    setTotal(headers['x-total-count'] || 0);
    hideLoading();
  }, 1000);

  useEffect(() => {
    const fetchProfiles = async () => {
      showLoading();
      const { error, data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/profiles/admins`,
        {
          headers: { Authorization: newToken },
        }
      );
      if (error) {
        setSubjects([]);
        return;
      }
      setSubjects(data);
    };

    fetchProfiles();
  }, []);

  useEffect(() => {
    fetchReports();
  }, [query]);

  function onFilter(queryDiff) {
    setQuery(queryDiff);
  }

  async function addPaymentDate(data) {
    const { error } = await addBonusPaymentDate({ newToken, data });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReports();
    alert.success(t('COMMON:SUCCESS_UPDATE'));
  }

  async function onBonusUpdate(data) {
    const { error } = await updateBonus({ newToken, data });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReports();
    alert.success(t('COMMON:SUCCESS_UPDATE'));
  }

  return (
    <EmittedIAFPresentational
      data={iafs}
      subjects={subjects}
      query={query}
      total={total}
      onFilter={onFilter}
      addPaymentDate={addPaymentDate}
      handleUpdateBonus={onBonusUpdate}
    />
  );
};

export default MyEmittedIAFPanoramica;
